<template lang="pug">
  b-list-group.lm-aside-menu(role='tablist')
    b-list-group-item.d-flex.align-items-center.px-4(
      tag='a'
      role='tab'
      :active="exact('/manager')"
      @click="handleClick({ name: 'manager' })")
      i.fal.fa-fw.fa-25w.fa-15x.fa-tachometer.flex-shrink-0
      span.pl-3
        | {{ $t('shared.menus.dashboard') }}

    b-list-group-item.d-flex.align-items-center.px-4(
      v-if='isAdmin'
      tag='a'
      role='tab'
      :active="starts('/manager/identities')"
      @click="handleClick({ name: 'manager-identities' })")
      i.fal.fa-fw.fa-25w.fa-15x.fa-shield-alt.flex-shrink-0
      span.pl-3
        | {{ $t('activerecord.models.identity.other') }}

    b-list-group-item.d-flex.align-items-center.px-4(
      v-if='isAM'
      tag='a'
      role='tab'
      :active="starts('/manager/accounts')"
      @click="handleClick({ name: 'manager-accounts' })")
      i.fal.fa-fw.fa-25w.fa-15x.fa-users.flex-shrink-0
      span.pl-3
        | {{ $t('activerecord.models.account.other') }}

    b-list-group-item.d-flex.align-items-center.px-4(
      v-if='isAMT'
      tag='a'
      role='tab'
      :active="starts('/manager/organizations')"
      @click="handleClick({ name: 'manager-organizations' })")
      i.fal.fa-fw.fa-25w.fa-15x.fa-building.flex-shrink-0
      span.pl-3
        | {{ $t('activerecord.models.organization.other') }}

    b-list-group-item.d-flex.align-items-center.px-4(
      v-if='isAMT'
      tag='a'
      role='tab'
      :active="starts('/manager/machines') && !starts('/manager/machines/models')"
      @click="handleClick({ name: 'manager-machines' })")
      i.fal.fa-fw.fa-25w.fa-15x.fa-conveyor-belt-alt.flex-shrink-0
      span.pl-3
        | {{ $t('activerecord.models.machine.other') }}

    b-list-group-item.d-flex.align-items-center.px-4(
      v-if='isAMT'
      tag='a'
      role='tab'
      :active="starts('/manager/firmwares')"
      @click="handleClick({ name: 'manager-firmwares' })")
      i.fal.fa-fw.fa-25w.fa-15x.fa-microchip.flex-shrink-0
      span.pl-3
        | {{ $t('activerecord.models.firmware.other') }}

    b-dropdown-divider.my-3.list-unstyled

    wc-language-switch.list-unstyled(
      toggle-class='list-group-item-action d-flex align-items-center px-4 py-3 text-body'
      dropup
      right
      no-caret)
</template>

<script>
import WcLanguageSwitch from '@components/shared/WcLanguageSwitch'
import { Menu } from '@common/menu'

export default {
  name: 'lm-aside-menu',
  mixins: [Menu],
  components: {
    WcLanguageSwitch,
  },
  computed: {
    isAM() {
      /* This $root is used because of a bug on server side. */
      return this.$root.$store.getters['auth/isAM']
    },
    isAMT() {
      /* This $root is used because of a bug on server side. */
      return this.$root.$store.getters['auth/isAMT']
    },
    isAdmin() {
      /* This $root is used because of a bug on server side. */
      return this.$root.$store.getters['auth/isAdmin']
    },
  },
  methods: {
    handleClick(params) {
      if (this.$store.getters['ui/isMediumDevice']) this.$store.dispatch('ui/toggleAside')
      this.$router.push(params)
    },
  },
}
</script>

<style lang="scss">
@import '@assets/css/plugins/bootstrap/config';

.l-manager {
  #aside,
  &.l-aside-closed #aside:hover {
    #sidebar-menu {
      .list-group {
        > .list-group-item {
          font-weight: $font-weight-bold;
        }
        .list-group-item {
          position: relative;
          border: 0;
          border-radius: 0;
          padding: 1rem 1.5rem;
          white-space: nowrap;
          color: $body-color;
          &.active span,
          &:hover span,
          i {
            color: $wc-primarydark;
          }
          .caret {
            display: block;
          }
        }
        .list-group-item.active,
        .list-group-item-action:hover,
        .list-group-item-action:focus {
          background-color: lighten($wc-primarylight, 20%);
        }
        .list-group-item-action > span,
        .accordion-collapse {
          display: inline-block;
          width: 100%;
          overflow: hidden;
          transition: $wc-transition-all-ease;
        }
        .accordion-collapse {
          max-height: 50rem;
        }
        .accordion-toggle.collapsed .caret:before {
          content: '\F105';
        }
      }
    }
  }

  &.l-aside-closed #aside {
    #sidebar-menu {
      .list-group {
        .list-group-item-action > span,
        .accordion-collapse {
          width: 0;
        }
        .accordion-collapse {
          max-height: 0;
        }
        > .list-group-item .caret {
          display: none;
        }
      }
    }
  }
}
</style>
